import React, { useCallback, useEffect, useState } from 'react';
import { deletePayrollClose, fetchPayrollCloses, savePayrollClose } from '../../services/adminService';

const MESES = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' },
];

const anios = () => {
  const actual = new Date().getFullYear();
  const lista = [];
  for (let anio = actual - 1; anio <= actual + 1; anio += 1) {
    lista.push(String(anio));
  }
  return lista;
};

const nombreMes = (mes) => {
  const encontrado = MESES.find((item) => item.id === mes);
  return encontrado ? encontrado.label : mes;
};

const NominaCierreQuincena = ({ sessionId, onSalir }) => {
  const hoy = new Date();
  const [quincena, setQuincena] = useState(hoy.getDate() <= 15 ? '1' : '2');
  const [mes, setMes] = useState(String(hoy.getMonth() + 1).padStart(2, '0'));
  const [anio, setAnio] = useState(String(hoy.getFullYear()));
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [eliminandoId, setEliminandoId] = useState(0);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  const cargar = useCallback(() => {
    setCargando(true);
    setError('');

    return fetchPayrollCloses(sessionId)
      .then((cierres) => {
        setLista(cierres);
      })
      .catch((requestError) => {
        setLista([]);
        setError(requestError.message || 'No se pudieron cargar los cierres.');
      })
      .finally(() => {
        setCargando(false);
      });
  }, [sessionId]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const guardar = () => {
    if (!quincena || !mes || !anio) {
      setError('Selecciona la quincena, el mes y el año.');
      setAviso('');
      return;
    }

    setGuardando(true);
    setError('');
    setAviso('');

    savePayrollClose(sessionId, { quincena, mes, anio })
      .then((cierres) => {
        setLista(cierres);
        setAviso('Quincena cerrada.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo cerrar la quincena.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  const eliminar = (id) => {
    setEliminandoId(id);
    setError('');
    setAviso('');

    deletePayrollClose(sessionId, id)
      .then((cierres) => {
        setLista(cierres);
        setAviso('Quincena abierta de nuevo.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo abrir la quincena.');
      })
      .finally(() => {
        setEliminandoId(0);
      });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-descuento-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Cierre de quincena</h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
        <p className="admin-muted">
          Una quincena cerrada no se podrá generar ni modificar cuando exista Crear nómina. Eliminar la fila la vuelve a dejar abierta.
        </p>
        {error ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {error}
          </div>
        ) : null}
        {aviso ? (
          <div className="admin-alert admin-alert--success" role="status">
            {aviso}
          </div>
        ) : null}
        <div className="nomina-descuento-reporte">
          <span>Quincena, mes y año</span>
          <div>
            <select value={quincena} onChange={(event) => setQuincena(event.target.value)}>
              <option value="1">Primera quincena</option>
              <option value="2">Segunda quincena</option>
            </select>
            <select value={mes} onChange={(event) => setMes(event.target.value)}>
              {MESES.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
            <select value={anio} onChange={(event) => setAnio(event.target.value)}>
              {anios().map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="nomina-descuentos-acciones">
          <button type="button" className="admin-btn admin-btn--primary" disabled={guardando} onClick={guardar}>
            {guardando ? 'Guardando…' : 'Guardar cierre'}
          </button>
          <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
            Salir
          </button>
        </div>
        {cargando ? <p className="admin-muted">Cargando…</p> : null}
        {!cargando && lista.length === 0 ? <p className="admin-muted">No hay quincenas cerradas.</p> : null}
        {!cargando && lista.length > 0 ? (
          <div className="admin-table-wrap nomina-lista-blanca">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Quincena</th>
                  <th>Mes cerrado</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {lista.map((item) => (
                  <tr key={item.id}>
                    <td>{item.quincena === '1' ? 'Primera' : 'Segunda'}</td>
                    <td>{nombreMes(item.mes)} {item.anio}</td>
                    <td>
                      <button
                        type="button"
                        className="admin-btn admin-btn--danger"
                        disabled={eliminandoId === item.id}
                        onClick={() => eliminar(item.id)}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NominaCierreQuincena;
